"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = void 0;
const schema_1 = require("../../../../../schema");
const comment = schema_1.Schema.string().optional().maxLength(1000).interpretation({
    vocab: "ltx",
    code: "nephrological_urological_disease_comment"
});
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ comment })
    .interpretation({
    vocab: "ltx",
    code: "nephrological_urological_disease_form"
});
